module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "ReportCard mb-5",
    attrs: {
      "text": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 pl-12"
  }, [_vm._v("\n      " + _vm._s(_vm.equipData.name) + "\n      "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "nudge-bottom": "10"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "size": 18,
            "color": "#757575"
          }
        }, on), [_vm._v("info_outline")])]
      }
    }])
  }, [_vm._v(" "), _c('p', {
    staticClass: "mb-0 body-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.$t("MainCard.brand")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.equipData.brand || '-'))])]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 body-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.$t("MainCard.flow")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.equipData.pumpFlow || '-') + " m3/h")])]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 body-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.$t("MainCard.area")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "14px !important"
    }
  }, [_vm._v(_vm._s(_vm.equipData.equipmentArea || '-') + " ha")])])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "EquipmentSummary px-12",
    attrs: {
      "row": "",
      "no-wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "EquipmentItem pa-0",
    attrs: {
      "xs3": ""
    }
  }, _vm._l((_vm.optLocations), function(loc, index) {
    return _c('div', {
      key: loc.id,
      class: {
        LocationOpt: true,
        Active: loc.checked,
        'd-flex': true,
        'align-start': true,
        'justify-start': true
      },
      on: {
        "click": function($event) {
          return _vm.toggleLoc(index)
        }
      }
    }, [(loc.isPublished === false) ? _c('v-icon', {
      staticClass: "UnpublishedIcon",
      attrs: {
        "color": "warning"
      }
    }, [_vm._v("priority_high")]) : _vm._e(), _vm._v(" "), (loc.checked) ? _c('v-icon', {
      staticClass: "mt-1",
      attrs: {
        "small": "",
        "color": "#0098E1"
      }
    }, [_vm._v("radio_button_checked")]) : _c('v-icon', {
      staticClass: "mt-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("radio_button_unchecked")]), _vm._v(" "), _c('CropIcon', {
      attrs: {
        "color": loc.checked ? '#0098E1' : '#757575',
        "classString": "",
        "name": loc.crop
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "subheading d-inline-block ml-1"
    }, [_vm._v(_vm._s(loc.label))])], 1)
  }), 0), _vm._v(" "), _vm._l((_vm.metricsData), function(item, i) {
    return _c('v-col', {
      key: _vm.metricsVisualData[i].label,
      staticClass: "EquipmentItem text-center pa-0",
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "subheading px-1"
    }, [_vm._v(_vm._s(_vm.metricsVisualData[i].label))]), _vm._v(" "), _c('v-badge', {
      attrs: {
        "color": "transparent"
      },
      scopedSlots: _vm._u([{
        key: "badge",
        fn: function() {
          return [(_vm.haveBadge('star', item.value, i)) ? _c('v-icon', {
            attrs: {
              "medium": "",
              "color": "#F8C300"
            }
          }, [_vm._v("star")]) : (_vm.haveBadge('alert', item.value, i)) ? _c('v-icon', {
            attrs: {
              "medium": "",
              "color": "#F93A2F"
            }
          }, [_vm._v("report")]) : _vm._e()]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (_vm.metricsVisualData[i].circular) ? _c('v-progress-circular', {
      staticClass: "ItemValue",
      attrs: {
        "rotate": -90,
        "size": 120,
        "width": 5,
        "value": item.value,
        "color": "#0098E1"
      }
    }, [_c('p', {
      staticClass: "display-1 ma-0",
      staticStyle: {
        "color": "#00202F"
      }
    }, [_vm._v(_vm._s(item.value.toFixed(0)))]), _vm._v(" "), (parseFloat(item.mod.value) === 0) ? _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_c('v-icon', {
      attrs: {
        "size": "12",
        "color": "grey"
      }
    }, [_vm._v("horizontal_rule")]), _vm._v("\n                " + _vm._s(item.mod.value) + "\n              ")], 1) : _c('p', {
      class: {
        caption: true,
        'ma-0': true,
        'light-green--text': _vm.isModGood(item.mod, i),
        'red--text': !_vm.isModGood(item.mod, i),
        'lighten-2': true
      }
    }, [(item.mod.neg) ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.isModGood(item.mod, i) ? 'light-green lighten-2' : 'red lighten-2'
      }
    }, [_vm._v("arrow_downward")]) : _c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.isModGood(item.mod, i) ? 'light-green lighten-2' : 'red lighten-2'
      }
    }, [_vm._v("arrow_upward")]), _vm._v("\n                " + _vm._s(item.mod.value) + "\n              ")], 1)]) : _c('div', {
      staticClass: "my-3 py-3"
    }, [_c('p', {
      staticClass: "display-1 ma-0 mb-1"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (parseFloat(item.mod.value) === 0) ? _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_c('v-icon', {
      attrs: {
        "size": "12",
        "color": "grey"
      }
    }, [_vm._v("horizontal_rule")]), _vm._v("\n                " + _vm._s(item.mod.value) + "\n              ")], 1) : _c('p', {
      class: {
        caption: true,
        'ma-0': true,
        'light-green--text': _vm.isModGood(item.mod, i),
        'red--text': !_vm.isModGood(item.mod, i),
        'lighten-2': true
      }
    }, [(item.mod.neg) ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.isModGood(item.mod, i) ? 'light-green lighten-2' : 'red lighten-2'
      }
    }, [_vm._v("arrow_downward")]) : _c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.isModGood(item.mod, i) ? 'light-green lighten-2' : 'red lighten-2'
      }
    }, [_vm._v("arrow_upward")]), _vm._v("\n                " + _vm._s(item.mod.value) + "\n              ")], 1)])], 1)], 1)
  })], 2), _vm._v(" "), (_vm.faultsEvery100hsAverage && _vm.faultsEvery100hs > _vm.faultsEvery100hsAverage) ? _c('div', {
    staticClass: "py-2 px-12",
    staticStyle: {
      "background-color": "#F3ECD8"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MainCard.auditMessage')) + " "), _c('a', {
    staticStyle: {
      "color": "#26A9E8"
    },
    on: {
      "click": _vm.requestAuditQuote
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('MainCard.quoteAudit')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pt-3"
  }, _vm._l((_vm.equipmentComments), function(comment, i) {
    return _c('p', {
      key: _vm.equipData.name + 'equip_comment' + i,
      staticClass: "EquipmentComment subheading mx-5 my-2"
    }, [_vm._v("*" + _vm._s(comment))])
  }), 0), _vm._v(" "), _c('CardExpansionPanel', {
    attrs: {
      "equipData": _vm.equipData,
      "locations": _vm.locations,
      "optLocations": _vm.optLocations,
      "title": _vm.equipData.name
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7deffb5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/MainCard.vue
// module id = 1740
// module chunks = 0